import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[numLimitMask]'
})
export class NumberLimitDirective {
  private _phoneControl:AbstractControl;
  private _preValue:string;
  private _numLen: number;
  @Output() metLimit = new EventEmitter();

  @Input() 
  set phoneControl(control:AbstractControl){
    this._phoneControl = control;
  }
  @Input() 
  set preValue(value:string){
    this._preValue = value;
  }
  @Input()
  set numLen(value: number) {
    this._numLen = value;
  }
  private sub:Subscription;
  
  constructor() { }

  ngOnInit(){
    this.validateLen();
 }

  validateLen(): void {
    this.sub = this._phoneControl.valueChanges.subscribe(data => {
        let preInputValue:string = this._preValue;
       
        // remove all mask characters (keep only numeric)
        var newVal = data.replace(/\D/g, '');
        if(newVal.length === this._numLen - 1) {
          this.metLimit.emit(true);
        } else {
          this.metLimit.emit(false);
        }
        if(data.length >= this._numLen) {
          newVal = preInputValue.replace(/\D/g, '');
          
        }
        this._phoneControl.setValue(newVal,{emitEvent: false});
    });
 }
 ngOnDestroy() {
  this.sub.unsubscribe(); 
}

}
